import styled from "styled-components";

export const EmptyActivity = () => {
  return <Wrapper></Wrapper>;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-left: 82px;
`;
